var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "店员详情",
        width: "80%",
        visible: _vm.dialogVisible,
        fullscreen: _vm.device === "mobile",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.dialogClose,
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "detailForm",
          attrs: {
            "element-loading-text": "加载中...",
            model: _vm.detail,
            rules: _vm.rules,
            "label-width": "100px",
            "label-position": _vm.device === "mobile" ? "top" : "right",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 12, md: 6 } },
                [
                  _c(
                    "el-form-item",
                    { staticStyle: { display: "none" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.detail.userId,
                          callback: function ($$v) {
                            _vm.$set(_vm.detail, "userId", $$v)
                          },
                          expression: "detail.userId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "用户昵称", prop: "userId" } },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: "请输入用户昵称或手机号查找" },
                          model: {
                            value: _vm.detail.nickName,
                            callback: function ($$v) {
                              _vm.$set(_vm.detail, "nickName", $$v)
                            },
                            expression: "detail.nickName",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.searchUser.apply(null, arguments)
                              },
                            },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 12, md: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "店员名称", prop: "userName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入店员名称" },
                        model: {
                          value: _vm.detail.userName,
                          callback: function ($$v) {
                            _vm.$set(_vm.detail, "userName", $$v)
                          },
                          expression: "detail.userName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, sm: 12, md: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号", prop: "mobile" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "number",
                          maxlength: "11",
                          placeholder: "请输入店员手机号",
                        },
                        model: {
                          value: _vm.detail.mobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.detail, "mobile", $$v)
                          },
                          expression: "detail.mobile",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.detail.id
                ? _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "登录密码", prop: "password" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入登录密码" },
                            model: {
                              value: _vm.detail.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "password", $$v)
                              },
                              expression: "detail.password",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { xs: 8, sm: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "系统管理员",
                        prop: "isAdmin",
                        "label-position": "right",
                      },
                    },
                    [
                      _c("el-switch", {
                        staticClass: "rectangle",
                        attrs: {
                          width: 60,
                          "active-color": "#13ce66",
                          "active-value": 1,
                          "inactive-value": 0,
                        },
                        model: {
                          value: _vm.detail.isAdmin,
                          callback: function ($$v) {
                            _vm.$set(_vm.detail, "isAdmin", $$v)
                          },
                          expression: "detail.isAdmin",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 8, sm: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "状态",
                        prop: "status",
                        "label-position": "right",
                      },
                    },
                    [
                      _c("el-switch", {
                        staticClass: "rectangle",
                        attrs: {
                          width: 60,
                          "active-color": "#13ce66",
                          "active-value": 1,
                          "inactive-value": 0,
                        },
                        model: {
                          value: _vm.detail.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.detail, "status", $$v)
                          },
                          expression: "detail.status",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "0px" } },
                    [
                      _c("ouer-transfer", {
                        attrs: {
                          height: "540px",
                          data: _vm.stores,
                          "left-props": _vm.leftProps,
                          "right-props": _vm.rightProps,
                          "button-texts": ["授权", "移除"],
                          headers: ["可选商家", "已授权商家"],
                        },
                        on: {
                          moveToRight: _vm.handleMoveToRight,
                          moveToLeft: _vm.handleMoveToLeft,
                        },
                        model: {
                          value: _vm.selectedStores,
                          callback: function ($$v) {
                            _vm.selectedStores = $$v
                          },
                          expression: "selectedStores",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.dialogClose } }, [
            _vm._v("取 消"),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("提交保存")]
          ),
        ],
        1
      ),
      _vm.showMemberInfo
        ? _c("member-info", {
            attrs: {
              show: _vm.showMemberInfo,
              data: _vm.memberInfo,
              title: "用户信息",
            },
            on: {
              "update:show": function ($event) {
                _vm.showMemberInfo = $event
              },
              close: _vm.handleCancel,
              submit: _vm.handleConfirm,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }